import { Property } from 'csstype';
import { CSSProperties, FC, ReactElement } from 'react';

export interface IStrongText {
    children?: ReactElement | string | number;
    className?: string;
    color?: string;
    font?: number | string;
    margin?: string | number;
    styles?: CSSProperties;
    weight?: number | string;
}

export type StrongTextProps = IStrongText;

const StrongText: FC<StrongTextProps> = ({
    className,
    children,
    weight = 700,
    font = 20,
    color = '#212529',
    margin,
    styles,
}) => {
    if (children) {
        return (
            <div
                className={className}
                style={{
                    fontSize: font,
                    color,
                    margin,
                    lineHeight: 1.5,
                    fontWeight: weight as Property.FontWeight,
                    ...styles,
                }}
            >
                {children}
            </div>
        );
    }

    return null;
};

export default StrongText;
